<template>
    <app-wrapper>
        <app-header medium-max-width="max-w-1000" :is-hidden-menu="true">
            <template #top>
                <div class="w-full flex items-center">
                    <div class="flex-auto text-center">
                        <h2 class="mb-1 mt-0 md:text-4xl">Activate Your New Loan Terms</h2>
                        <span class="text-gray-500">Please review your updated loan details before activating.</span>
                    </div>
                </div>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-1000">

            <template #main>


                <AppBoxContent 
                    class="mt-4 mb-6"
                    width="full" 
                    rounded="lg"
                    bg-class-color="bg-white" 
                    :use-min-height="false"
                    :remove-max-width="true"
                >
                    

                    <div>
                        <div class="summary flex flex-col gap-6 border border-[#f3f3f3] bg-[#EDEDED40] p-6 rounded-lg text-black">
                            <h5 class="text-lg">New Loan Summary</h5>

                            <div>
                                <p><FontBold class="text-xl">{{ (storeData.payoff + storeData.advancedRefiMaxCashBack) | formatMoney }}</FontBold></p>
                                <p>New loan amount</p>
                            </div>

                            <div>
                                <p><FontBold class="text-xl">{{ storeData.advancedRefiMaxCashBack | formatMoney }}</FontBold></p>
                                <p>Cash available</p>
                            </div>
                        </div>

                        <div class="loan-details p-6">
                            <h5 class="text-lg mb-6">Loan Details</h5>

                            <div class="flex mb-2">
                                <div class="min-w-[150px]">Loan term</div>
                                <div>24 months</div>
                            </div>

                            <div class="flex">
                                <div class="min-w-[150px]">Monthly payment</div>
                                <div>{{ storeData.paymentAmount | formatMoney }}</div>
                            </div>
                        </div>

                        <SimpleDivider class="my-2" />

                        <div class="flex p-6">
                            <div class="min-w-[150px]">Previous loan</div>
                            <div>{{ storeData.loanAmount | formatMoney }}</div>
                        </div>
                    </div>

                </AppBoxContent>
                

                <div class="action-buttons text-center mt-4">
                    <div v-if="errors.global" class="mb-4 p-4 bg-red-50 rounded-lg border border-red-200">
                        <p class="text-red-800 text-sm">{{ errors.global }}</p>
                    </div>
                    <div v-if="errors.cash_back_amount" class="mb-4 p-4 bg-red-50 rounded-lg border border-red-200">
                        <p class="text-red-800 text-sm">{{ errors.cash_back_amount }}</p>
                    </div>
                    <div>
                        <LinkButton 
                            class="mb-1" 
                            data-testid="submit-refi"
                            href="#" 
                            @click.prevent="submitRefi()"
                            :disabled="loading"
                            type="orange">{{ loading ? 'Processing...' : 'Confirm & Receive ' + formatMoney(storeData.payoff + storeData.advancedRefiMaxCashBack) }}</LinkButton>
                    </div>
                    <div>
                        <LinkButton 
                            :href="storeData.portalUrl" 
                            type="grey">Return to Portal</LinkButton>
                    </div>
                </div>

            </template>
        </app-body>
    </app-wrapper>
</template>

<script>
import AppBoxContent from '../../../../components/AppBoxContent.vue';
import FontBold from '../components/FontBold.vue';
import SimpleDivider from '../components/SimpleDivider.vue';
import LinkButton from '../components/LinkButton.vue';
import { RefinanceStepMixin } from './../mixins/RefinanceStepMixin';
import { RefinanceFiltersMixin } from './../mixins/RefinanceFiltersMixin';

export default {
    name: 'NewLoanConfirmation',
    mixins: [RefinanceStepMixin, RefinanceFiltersMixin],
    components: {
        AppBoxContent,
        FontBold,
        SimpleDivider,
        LinkButton,
    },

    data() {
        return {
        }
    },
}
</script>
